// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"270":"operational-diversification","443":"about","501":"smart-trading","631":"contact"}[chunkId] + "." + {"270":"09640dcb","443":"00e6b34f","501":"c506e7c0","631":"1ed3fa2b"}[chunkId] + ".js";
};